import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { DateService } from '@moawen-workspace/agency/core';
import { forkJoin, tap } from 'rxjs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'shared-preview-image',
  standalone: true,
  imports: [CommonModule, TranslocoModule, MatProgressSpinnerModule],
  templateUrl: './preview-image.component.html',
  styleUrl: './preview-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewImageComponent implements OnChanges {
  loader = "https://media1.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif";
  dateService = inject(DateService);
  #cdr = inject(ChangeDetectorRef);

  @Input() previewData: any;
  @Input() previewLabel: any;
  @Input() acrossIcon: any = false;
  @Input() responseImg: any;
  @Input() viewDocs: any;
  @Output() imgData = new EventEmitter<any>();
  @Input() cssStyle:any='col-md-3';
  @Input() previewStar = false;

  images: any = {};
  imgPath: any;
  imagesLoaded = false;
  @Input() remove_id = 'id';


  ngOnChanges() {
    this.imagesLoaded = true;
    if (this.viewDocs && this.previewData?.length) {
      const imageFetches = this.previewData.map((doc: any) => {
        const file = doc.filePath;
        return this.dateService.getImageUrl(file).pipe(
          tap((res: any) => {
            this.imagesLoaded = false;
            this.images[file] = res?.result??'https://placehold.co/600x400/EEE/31343C';
          })
        );
      });
      forkJoin(imageFetches).subscribe(() => {
        this.previewData.forEach((img:any) => {
          const actualUrl = this.images[img.filePath];
          if (actualUrl) {
            img.responsePath = actualUrl; // Overwrite with final image URL
          }
        })
        this.#cdr.detectChanges();
        console.log('All images loaded!');
      });
    } else {
      this.imagesLoaded = false;
    }
  }

  removeItems(data: any) {
    this.imgData.emit(data);
  }

}
